// Added by Sejune Oh on 2020-04-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableFooter as MaterialUITableFooter,
    TableFooterProps as MaterialUITableFooterProps
} from '@material-ui/core'

interface TableFooterBaseProps { }
export type TableFooterProps = Partial<MaterialUITableFooterProps> & TableFooterBaseProps

export const TableFooter: FC<TableFooterProps> = ({ ...props }) => {
    return <MaterialUITableFooter {...props}></MaterialUITableFooter>
}
